<template>
    <div class="achievementRecord">
        <el-row>
            <el-col :span="24">
                <div class="information">
                    <div class="informationCenter">
                        <div class="informationTitle">
                            <Title text="我的成绩" />
                        </div>
                        <div class="elTabs">
                            <div class="informationDiv">
                                <el-table style="width:99%" :data="dataList" headerRowClassName="uni-primary-table-header" stripe border>
                                    <el-table-column prop="start_year" align="center" label="学年"></el-table-column>
                                    <el-table-column prop="start_semester" align="center" label="学期"></el-table-column>
                                    <el-table-column prop="course_title" align="center" label="课程">
                                    </el-table-column>
                                    <el-table-column prop="score" align="center" label="成绩"></el-table-column>

                                </el-table>
                            </div>

                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import {adultStudentNewScoreRecord} from '@/api/exam';
export default {
    name: "achievementRecord",
    data() {
        return {
            activeName: "examination",
            dataList: [],
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        // 获取数据
        async getData() {
            const { result } = await adultStudentNewScoreRecord();
            if (result) {
                this.dataList = result;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.information {
    min-height: $contentH;
    padding: 20px 20px 0 20px;
    /deep/ .el-table .cell {
        padding: 5px 0;
    }
}
.informationCenter {
    width: 100%;
    min-height: inherit;
    background-color: #fff;
}
.informationTitle {
    display: flex;
    align-items: center;
}
.elTabs {
    padding: 0 20px;
}
.informationTitle span {
    display: inline-block;
    width: 4px;
    height: 23px;
    background-color: #1459a6;
}
.informationTitle {
    padding-left: 20px;
}
.informationDiv {
    width: 100%;
    margin-top: 28px;
}

.link-btn {
    height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.averageScoreClass{
   width: 100%;
   text-align: right;
   padding-right: 50px;
}
</style>
